'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { motion, type Variants } from 'motion/react';
import { getVariants, useAnimateIconContext, IconWrapper, type IconProps } from '@/components/animate-ui/icons/icon';
type ClockProps = IconProps<keyof typeof animations>;
const animations = {
  default: {
    circle: {},
    line1: {
      initial: {
        rotate: 0,
        transition: {
          ease: 'easeInOut',
          duration: 0.6
        }
      },
      animate: {
        transformOrigin: 'top left',
        rotate: [0, 20, 0],
        transition: {
          ease: 'easeInOut',
          duration: 0.6
        }
      }
    },
    line2: {
      initial: {
        rotate: 0,
        transition: {
          ease: 'easeInOut',
          duration: 0.6
        }
      },
      animate: {
        transformOrigin: 'bottom left',
        rotate: 360,
        transition: {
          ease: 'easeInOut',
          duration: 0.6
        }
      }
    }
  } satisfies Record<string, Variants>
} as const;
function IconComponent(t0) {
  const $ = _c(14);
  let props;
  let size;
  if ($[0] !== t0) {
    ({
      size,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = size;
  } else {
    props = $[1];
    size = $[2];
  }
  const {
    controls
  } = useAnimateIconContext();
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getVariants(animations);
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const variants = t1;
  let t2;
  let t3;
  let t4;
  if ($[4] !== controls) {
    t2 = <motion.circle cx={12} cy={12} r={10} variants={variants.circle} initial="initial" animate={controls} />;
    t3 = <motion.line x1={12} y1={12} x2={16} y2={14} variants={variants.line1} initial="initial" animate={controls} />;
    t4 = <motion.line x1={12} y1={6} x2={12} y2={12} variants={variants.line2} initial="initial" animate={controls} />;
    $[4] = controls;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== props || $[9] !== size || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = <motion.svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" {...props}>{t2}{t3}{t4}</motion.svg>;
    $[8] = props;
    $[9] = size;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
function Clock(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <IconWrapper icon={IconComponent} {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export { animations, Clock, Clock as ClockIcon, type ClockProps, type ClockProps as ClockIconProps };